export const DASHBOARD_ROOT_ROUTE = '/dashboard'
export const DASHBOARD_MODULE_ROUTE = `:id`

export const getDashboardRoute = () => `${DASHBOARD_ROOT_ROUTE}`

const getRouteWithInjectedModuleId = (route: string, moduleId: string) =>
  route.replace(':id', `${moduleId}`)

export const getDashboardModuleRoute = (moduleId: string) =>
  `${getDashboardRoute()}/${getRouteWithInjectedModuleId(
    DASHBOARD_MODULE_ROUTE,
    moduleId,
  )}`
